<template>
  <v-row dense>
    <v-col cols="12">
    <span class="caption font-weight-bold">Armazém</span>
    <div>
      {{ formData.ARMAZEM | truncate(45) }}
    </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
